<script lang="ts">
  let {
    label,
    value = $bindable(''),
    placeholder = '',
    type = 'text',
    disabled = false,
    error = '',
    required = false,
    oninput = () => {},
    onchange = () => {}
  }: {
    label: string;
    value?: string;
    placeholder?: string;
    type?: 'text' | 'number' | 'email' | 'password' | 'date';
    disabled?: boolean;
    error?: string;
    required?: boolean;
    oninput?: () => void;
    onchange?: () => void;
  } = $props();

  const inputId = `input-${Math.random().toString(36).substr(2, 9)}`;
</script>

<div class="form-input">
  <label for={inputId}>
    {label}
    {#if required}
      <span class="required">*</span>
    {/if}
  </label>
  <input
    id={inputId}
    {type}
    {placeholder}
    {disabled}
    {required}
    bind:value
    {oninput}
    {onchange}
    class:error={error}
  />
  {#if error}
    <span class="error-message">{error}</span>
  {/if}
</div>

<style lang="scss">
  .form-input {
    display: flex;
    flex-direction: column;
    gap: var(--spacing-sm);

    label {
      font-size: var(--font-size-sm);
      font-weight: var(--font-weight-medium);
      color: var(--color-text-secondary);

      .required {
        color: var(--color-danger);
        margin-left: var(--spacing-xs);
      }
    }

    input {
      padding: var(--spacing-sm) var(--spacing-md);
      border: 1px solid var(--color-border);
      border-radius: var(--radius-md);
      font-size: var(--font-size-sm);
      background: var(--color-background);
      transition: all var(--transition-fast);

      &:focus {
        outline: none;
        border-color: var(--color-primary);
        box-shadow: var(--shadow-focus-ring);
      }

      &:hover:not(:disabled) {
        border-color: var(--color-text-muted);
      }

      &:disabled {
        background: var(--color-background-tertiary);
        cursor: not-allowed;
        opacity: 0.6;
      }

      &.error {
        border-color: var(--color-danger);

        &:focus {
          box-shadow: var(--shadow-focus-ring-danger);
        }
      }
    }

    .error-message {
      font-size: var(--font-size-xs);
      color: var(--color-danger);
      margin-top: var(--spacing-xs);
    }
  }
</style>
